<template>
  <div
    class="menu-content-label"
    :class="{
      'menu-content-label--active': $route && to.indexOf($route.name) >= 0,
      'menu-content-label--big': big,
      'menu-content-label--small': !big
    }"
    :data-to="`/${$store.state.lang}${to}`"
    @click="$eventHub.$emit('menu-navigate', { url: `/${$store.state.lang}${to}` })"
    data-apollo-hover
    :data-apollo-hover-animation="big ? 'opacity' : 'scale-center'"
  >
    <div
      class="menu-content-label__wrapper"
      @mouseenter="mouseEnter"
      @mouseleave="mouseLeave"
    >
      <div class="menu-content-label__up">{{ upLabel }}</div>
      <span>{{ label }}</span>
    </div>
  </div>
</template>

<script>
import TweenMax from 'gsap/TweenMaxBase';
import animations from '@/assets/animations';
import { SplitText } from '@/scripts/libs/SplitText';
import { isTouchDevice } from '../../scripts/utils';

export default {
  name: 'MenuContentLabel',

  props: ['label', 'upLabel', 'big', 'to'],

  data() {
    return {
      hoverTimeline: null,
    };
  },

  mounted() {
    this.$nextTick(() => {
      const split = new SplitText(this.$el.querySelector('.menu-content-label__up'));
      TweenMax.set(split.chars, { yPercent: 20, autoAlpha: 0 });
      this.hoverTimeline = animations.get('menu-content-label-hover')(this.$el, split);
    });
  },

  methods: {
    mouseEnter() { if (!isTouchDevice()) this.hoverTimeline.play(); },
    mouseLeave() { if (!isTouchDevice()) this.hoverTimeline.reverse(); },
  },
};
</script>

<style lang="scss" scoped>
.menu-content-label {
  position: relative;
  margin-right: calc((100vw / 32) * 1);
  cursor: pointer;

  @include mq($until: ipadP) {
    display: inline-block;
  }

  span {
    color: $color-dark;
    font-size: rem(22px);
    font-size: $font-size-text;
    transition: color .6s $inOutCubic;
  }

  &--small {
    @extend %bottom-line;

    &.menu-content-label--active::after {
      transform: scaleX(1);
    }
  }

  &--big {
    span {
      font-size: rem(60px);
      font-size: calc(60px * var(--rw));
      font-weight: 300;

      @include mq($until: ipadP) {
        font-size: rem(60px);
        font-size: calc(60px * var(--rw));
      }
    }

    .menu-content-label__up {
      position: absolute;
      width: 100%;
      top: -25px;
      left: 0px;
      text-transform: uppercase;
      font-size: rem(20px);
      font-size: calc(20px * var(--rw));
      font-weight: bold;
      letter-spacing: 0.01em;
      color: $color-primary;
      font-family: 'IGT Frankling Gothic';

      @include mq($until: ipadP) {
        display: none;
      }
    }

    &.menu-content-label--active::after {
      transform: scaleX(1);
    }

    &::before,
    &::after {
      content: ' ';
      position: absolute;
      left: 0px;
      width: 100%;
      height: 1px;
      background-color: $color-primary;
      transform: scaleX(0);
      transform-origin: 0% 50%;
      transition: transform .6s $inOutCubic;
    }

    &::before {
      top: 0px;
      transition-delay: .1s;
    }

    &::after {
      bottom: 0px;
    }

    &:hover {
      span {
        color: $color-primary;
      }

      &::before,
      &:after {
        transform: scaleX(1);

        @include mq($and: $is-touch-device) {
          transform: scaleX(0);
        }
      }
    }
  }

  &:not(.menu-content-label--big):nth-child(3) {
    margin-right: 0px;
  }
}
</style>
